import { useState } from "react";
import { Outlet } from "react-router-dom";
import { useSWRConfig } from "swr";
import { PageBreadcrumb } from "@/components/page-breadcrumb";
import { RefreshButton } from "@/components/list/refresh-button";
import { RouteTabs } from "@/components/nav/route-tabs";

const Index = () => {
  const { mutate } = useSWRConfig();
  const [spinning, setSpinning] = useState(false);

  // One refresh for whichever versions tab is open: revalidate every
  // "/versions*" key (list filters and audits alike).
  const refresh = async () => {
    setSpinning(true);
    try {
      await mutate(
        (key) =>
          Array.isArray(key) &&
          typeof key[0] === "string" &&
          key[0].startsWith("/versions")
      );
    } finally {
      setSpinning(false);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <PageBreadcrumb current="Versions" className="mb-0" />
      {/* Version creation lives on each app's page (app-scoped); the global
          list is read-only browsing, so no New Version here. */}
      <RouteTabs
        items={[
          { name: "Versions", to: "/versions", end: true },
          { name: "Audits", to: "/versions/audits" },
        ]}
        action={<RefreshButton spinning={spinning} onClick={refresh} />}
      />
      <Outlet />
    </div>
  );
};

export default Index;
